import {
  readPrintSettings,
  writePrintSettings,
  readPrintWarningSettings,
  writePrintWarningSettings,
} from '../../../pages/settings/printing/print-settings-storage-manager';
import { LogRocketAnalyticsService } from '../../../services/analytics-services/log-rocket';
import { initPrBuildService } from '../../../services/pr-build-service';

export const phase4Call = () => {
  // oxlint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    try {
      initPrBuildService();
      LogRocketAnalyticsService.init();

      const printSettings = readPrintSettings();
      writePrintSettings(printSettings);

      const printWarningSettings = readPrintWarningSettings();
      writePrintWarningSettings(printWarningSettings);

      resolve({
        printSettings,
        printWarningSettings,
      });
    } catch (e) {
      reject(e);
    }
  });
};
